import React, { useState } from 'react';
import { Div, colors, weight } from 'globalStyle';
import { useUser, useWallet } from 'hooks';
import { useSelector, useDispatch } from 'react-redux';
import { closePopUp, openPopUp } from 'store/popup';
import { useLocation as useLoc } from 'hooks/useLocation';
import { TextLight, TextMoneyDecimal } from 'components/Texts';
import { Hollow } from 'components/Buttons/';
import { PayInterbank } from 'Layout/components/Menu/components/AvailableMoney/PayInterbank';
import eye from 'assets/icons/eye.svg';
import noEye from 'assets/icons/no-eye.svg';
import reload from 'assets/icons/reload.svg';
import styled from 'styled-components';
import { RechargeStatus } from 'Layout/components/Menu/components/AvailableMoney/RechargeStatus';
import Skeleton from 'react-loading-skeleton';
import RechargeNotAvailable from './modals/RechargeNotAvailable';

export const CardBalance = ({ bgColor = colors.background.GRAY_3, pd }) => {
  const [modal, setModal] = useState(false);
  const { location } = useLoc();
  const { user } = useUser();
  const {
    defaultWallet, fetch, isLoadingWallet, setValuesVisibility, visible,
  } = useWallet({
    useCache: () => location
      && location.current.includes('/perfil')
      && location.previous.includes('/perfil'),
  });

  const handelDrop = () => {
    setValuesVisibility(!visible);
  };

  const dispatch = useDispatch();
  const isOpen = useSelector((store) => store.popup.isOpen);
  const handleClose = () => dispatch(closePopUp());

  const handleInterbank = () => {
    dispatch(openPopUp({ type: 'interbank' }));
  };

  if (isLoadingWallet) {
    return <Skeleton height="100%" style={{ marginBottom: '20px' }} />;
  }
  return (
    <Div
      isFlex
      direction="column"
      justify="space-between"
      align="start"
      height="100%"
      p={pd || '12px 15px'}
      width="100%"
      backgroundColor={bgColor}
      radius="15px"
    >
      <Div width="100%" isFlex justify="space-between">
        <Div
          onClick={() => {
            fetch();
          }}
        >
          <img
            src={reload}
            alt="recargar saldo"
            style={{ cursor: 'pointer' }}
          />
        </Div>
        <Div>
          <TextLight size={14} weight={weight.BOLD}>
            Saldo
          </TextLight>
        </Div>
        <Div>
          <Img src={visible ? eye : noEye} alt="icon" onClick={handelDrop} />
        </Div>
      </Div>

      <Div
        width="100%"
        height="100%"
        isFlex
        direction="column"
        justify="space-evenly"
      >

        <Div isFlex justify="space-between" width="100%">
          <TextLight size={13} weight={weight.SEMI_BOLD} align="start">
            Saldo total:
          </TextLight>
          <TextMoneyDecimal
            sizeInt={13}
            sizeDecimal={10}
            value={
              (defaultWallet?.displayValue || 0) + (defaultWallet?.unconfirmedAvailableAmount || 0)
            }
            isHiddenValue={!visible}
          />
        </Div>
      </Div>

      <Div isFlex width="100%" justify="space-between">
        <Hollow
          isSubmit
          onClick={() => {
            handleInterbank();
          }}
          padding="7px 0"
          size="12px"
          onColorType="white"
          color={colors.primary}
          style={{ borderRadius: '20px', width: '48%' }}
        >
          Retirar
        </Hollow>

        <Hollow
          isSubmit
          onColorType="primary"
          onClick={() => setModal(!modal)}
          padding="7px 0"
          size="12px"
          style={{ borderRadius: '20px', width: '48%' }}
        >
          Recargar
        </Hollow>
      </Div>

      {isOpen && <PayInterbank isOpen={isOpen} onClick={handleClose} />}

      {modal && (
        <RechargeNotAvailable
          open={modal}
          zIndex={10000}
          userData={user?.info}
          onClose={() => {
            setModal(false);
          }}
        />
      )}

      <RechargeStatus />
    </Div>
  );
};

const Img = styled.img`
  width: 18px;
  height: 18px;
  cursor: pointer;
`;
